module.exports = __webpack_public_path__ + "static/media/location.e7ce92ca.svg";